import { Skeleton, Tooltip } from "antd";
import React from "react";
import { ICONS } from "../../../assets/icons";
import { getRandomColorsBassedOnLetters } from "../../../helper/colors";

const TeamInbox = ({
  secondaryToggle,
  setSecondaryToggle,
  teamMembers,
  loading,
  handleItemClick,
  activeNav,
}) => {
  return (
    <div>
      <div
        className="flex-row align-center sidebar-header py-2 pointer"
        onClick={() => {
          setSecondaryToggle((prev) => ({
            ...prev,
            team: !prev?.team,
          }));
        }}
      >
        <img
          src={ICONS?.sidebarChevronDown}
          alt="icon"
          className={`w-3 mr-10 ${secondaryToggle["team"] ? "" : "rotate-180"}`}
        />
        <span>Team Members</span>
      </div>
      {secondaryToggle["team"] && (
        <Skeleton
          active
          style={{
            width: "20vw",
            padding: "20px",
          }}
          loading={loading}
          paragraph={{ rows: 2 }}
          className=".ant-skeleton-paragraph >li +li"
        >
          {teamMembers?.map((members, index) => {
            const firstLetter =
              members?.user_name?.slice(0, 1).toUpperCase() || "";
            const colors = getRandomColorsBassedOnLetters(firstLetter);
            return (
              <div
                key={index}
                onClick={() => {
                  handleItemClick(members);
                }}
                className={`w-[100%] b-radius-6 flex-row align-center mt-10 pl-10  overflow-scroll pointer ${
                  activeNav === members?.user_name
                    ? "sidebar-sub-header-active pb-10"
                    : "sidebar-sub-header hover:bg-slate-100 pb-10"
                }`}
                // className="flex-row align-center ml-10 mt-10 overflow-scroll pointer"
              >
                <Tooltip
                  title={members?.user_name?.length > 15 && members?.user_name}
                >
                  <div className="flex flex-row gap-2.5 truncate w-100 items-center mt-10 capitalize">
                    <span
                      className="w-9 h-7 rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                      style={{
                        color: "white",
                        backgroundColor: getRandomColorsBassedOnLetters(
                          members?.user_name?.slice(0, 1).toUpperCase(),
                          1.5
                        ).backgroundColor,
                      }}
                    >
                      {members?.user_name?.slice(0, 1).toUpperCase()}
                    </span>
                    <span className="truncate w-100 font14px-400 text-[var(--font-600)]">
                      {members?.user_name}
                    </span>
                  </div>
                </Tooltip>
              </div>
            );
          })}
        </Skeleton>
      )}
    </div>
  );
};

export default TeamInbox;
